import { ChilizLogoRounded, useFormatter, useIntl } from '@capsicum/common';
import { useAtomValue } from 'jotai';

import { ncwSendAssetAtom, ncwTransferAmountAtom } from '../../data-access';
import { useWalletNetworks } from '../useWalletNetworks';

export const useNCWSendResumeDrawer = () => {
	const { $t } = useIntl();
	const { chainExplorerUrl } = useWalletNetworks();
	const { formatCrypto } = useFormatter();
	const sendAsset = useAtomValue(ncwSendAssetAtom);
	const transferAmount = useAtomValue(ncwTransferAmountAtom);
	const assetWithAmount = formatCrypto(transferAmount || 0, sendAsset?.shortCode as string);
	const partnerLogo = sendAsset?.assetType === 'chiliz' ? ChilizLogoRounded : sendAsset?.imageUri;

	return {
		$t,
		chainExplorerUrl,
		intlText: {
			backButtonText: $t('ncWallet.send.resume.backButtonText'),
			description: $t('ncWallet.send.resume.description', { assetWithAmount }),
			title: $t('ncWallet.send.resume.title')
		},
		partnerLogo
	};
};
